/**
 * Router Configuration -- Product Management Portal
 */
import type { RouteRecordRaw } from 'vue-router';
import { AppLayout } from '@/shared/components';
import { productsRoutes } from '@/modules/products';
import { onboardingRoutes } from '@/modules/onboarding';
import { usersRoutes } from '@/modules/users';
import { recallRoutes } from '@/modules/recall';
import { enterprisesRoutes } from '@/modules/enterprises';
import { settingsRoutes } from '@/modules/settings';
import { auditLogsRoutes } from '@/modules/audit-logs';
import { emailCustomizationRoutes } from '@/modules/email-customization';
import { authRoutes } from '@/modules/auth';
import { myProfileRoutes } from '@/modules/my-profile';

export const routes: RouteRecordRaw[] = [
  // ── Auth routes (no AppLayout, no auth required) ─────────────────────────
  ...authRoutes,

  // ── Authenticated no-access page (no AppLayout) ─────────────────────────
  {
    path: '/no-access',
    name: 'no-access',
    component: () => import('../views/NoAccessView.vue'),
    meta: { requiresAuth: true },
  },

  // ── Protected app routes ─────────────────────────────────────────────────
  {
    path: '/',
    component: AppLayout,
    meta: { requiresAuth: true },
    children: [
      { path: '', redirect: '/products' },
      ...productsRoutes,
      ...onboardingRoutes,
      ...usersRoutes,
      ...recallRoutes,
      ...enterprisesRoutes,
      ...auditLogsRoutes,
      ...settingsRoutes,
      ...emailCustomizationRoutes,
      ...myProfileRoutes,
    ],
  },

  // 404 catch-all
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: () => import('../views/NotFoundView.vue'),
  },
];
